import { render } from "./SessionResults.vue?vue&type=template&id=4c5dce7a&scoped=true"
import script from "./SessionResults.vue?vue&type=script&lang=js"
export * from "./SessionResults.vue?vue&type=script&lang=js"

import "./SessionResults.vue?vue&type=style&index=0&id=4c5dce7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5dce7a"]])

export default __exports__